import { Info, ScanBarcode, Undo2 } from 'lucide-react'
import { useId, useState } from 'react'

import { Button } from '@krp/ui-kit'

import '../../../shared/ui/aqsi.css'
import { normalizeReceiptNumber } from '../model/receiptNumber'
import type { RefundLookupActions } from '../model/types'

/**
 * Возврат по номеру чека: поле принимает набор руками и ввод сканера (сканер
 * «печатает» номер и жмёт Enter). Чек ищется в нашей сохранённой копии журнала
 * этого кабинета при открытии окна возврата: нет копии - окно скажет «Чек не
 * найден», деньги к этому моменту не затрагиваются.
 */
export function RefundLookupScreen({ actions }: { actions: RefundLookupActions }) {
  const id = useId()
  const [value, setValue] = useState('')
  const receiptId = normalizeReceiptNumber(value)
  return (
    <section className="aqsi-screen" aria-labelledby="aqsi-refund-lookup-title">
      <header className="aqsi-toolbar">
        <h2 id="aqsi-refund-lookup-title">
          <Undo2 size={18} aria-hidden="true" /> Возврат по номеру чека
        </h2>
      </header>
      <form
        className="aqsi-form"
        aria-label="Поиск чека для возврата"
        onSubmit={(event) => {
          event.preventDefault()
          if (receiptId !== '') actions.open(receiptId)
        }}
      >
        <label htmlFor={id}>
          <ScanBarcode size={16} aria-hidden="true" /> Номер чека
        </label>
        <input
          id={id}
          className="sale__qty-input"
          autoFocus
          autoComplete="off"
          inputMode="text"
          placeholder="Введите номер или отсканируйте штрихкод чека"
          value={value}
          onChange={(event) => setValue(event.target.value)}
        />
        <div className="aqsi-card__actions">
          <Button type="submit" variant="primary" icon={<Undo2 size={14} aria-hidden="true" />} disabled={receiptId === ''}>
            Найти чек
          </Button>
        </div>
      </form>
      <p className="aqsi-caption" role="note">
        <Info size={14} aria-hidden="true" /> Позиции, цены, НДС и способ оплаты берутся из сохранённой копии чека. Если
        чека в копии нет, возврат не начнётся.
      </p>
    </section>
  )
}
